<template>
  <div id="aqt_content">
    <div class="content_body">
      <div class="details_head">
        <div class="line line1"></div>
        <p class="details_title">
          {{ details.title }}
        </p>
        <hr/>
        <div class="details_head_item">
          <p class="details_time">{{ details.addtime }}</p>
          <p class="details_from">{{ details.publisher }}</p>
        </div>
        <div class="details_content">
          <p class="paragraph" v-html="details.content"></p>
          <img :src="details.img" class="details_img"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$http = axios
export default {
  data() {
    return {
      details: [],
    }
  },
  mounted() {
    // const that = this
    // const url = 'http://admin.aqitai.com/Home/Index/NewsInfo?id=' + that.$route.query.id
    axios.get('http://oaapi.aqitai.com/api/v1/News/find?id=' + this.$route.query.id).then(response => {
      const result = response.data.data
      this.details = result
    }).catch(error => {
      alert('当前网络不佳...')
    })
  }
}
</script>

<style scoped lang="less">
#aqt_content {
  margin-top: 2rem;
  
  .content_body {
    width: 70%;
    height: auto;
    margin: 0px auto;
    padding-top: 40px;
    
    .details_head {
      width: 100%;
      height: auto;
      
      .line {
        width: 10%;
        height: 1px;
      }
      
      .line1 {
        background-color: #F5A623;
        margin: 50px auto;
      }
      
      .details_title {
        font-size: 17px;
        color: #F4FAFF;
        letter-spacing: 3px;
        line-height: 30px;
      }
      
      .details_head_item {
        width: 100%;
        height: 20px;
        margin-top: 1%;
        display: flex;
        flex-direction: row;
        
        .details_time {
          width: 55%;
          height: 100%;
          font-size: 10px;
          color: #D3DFFF;
        }
        
        .details_from {
          width: 35%;
          height: 100%;
          font-size: 10px;
          color: #D3DFFF;
          margin-left: 50%;
          text-align: right;
        }
      }
      
      .details_content {
        width: 100%;
        height: auto;
        margin-top: 5%;
        
        .paragraph {
          width: 100%;
          color: #D3DFFF;
          font-size: 14px;
          line-height: 25px;
          letter-spacing: 2px;
          text-indent: 2rem;
          
          /deep/ p img {
            width: 100%;
            
            margin-left: -5%;
          }
        }
        
        .details_img {
          width: 100%;
        }
      }
    }
  }
}
</style>
